<template>
    <div class="spinner">
        <div class="spinner-child bounce1"></div>
        <div class="spinner-child bounce2"></div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    show: {
        type: Boolean,
        required: false
    }
});

const show = ref(props.show);
</script>

<style type="text/css">
.spinner {
    width: 40px;
    height: 40px;
    position: relative;
    margin: 40px auto;
}

.spinner .spinner-child {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #333;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-animation: spinner-bounce 2s infinite ease-in-out;
    animation: spinner-bounce 2s infinite ease-in-out;
}

.spinner .bounce2 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}

@-webkit-keyframes spinner-bounce {
    0%, 100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    50% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}

@keyframes spinner-bounce {
    0%, 100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    50% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
</style>
